export const locale = {
    lang: 'fr',
    data: {
        'NAV': {
            'APPLICATIONS': 'APPLICATIONS',
            'SAMPLE': {
                'TITLE': 'Echantillon',
                'BADGE': '15'
            },
            'CUSTOM-FUNCTION': 'FONCTION PERSONNALISÉE',
            'CUSTOMIZE': 'Personnaliser',
            'MONITORING': 'Monitoring',
            'DASHBOARD': 'Tableau de bord',
            'GNC': 'Amélioration continue',
            'NON-CONFORMITE': 'Non Conformités',
            'RECLAMATION': 'Réclamations',
            'ACTIONS': 'Actions',
            'CALENDAR': 'Calendrier',
            'AUDIT': 'Audit',
            'NORME': 'Norme',
            'CHAPITRE': 'Chapitre',
            'BILAN_ANALYSE': 'Bilan et analyse',
            'ENQUETE': 'Enquêtes de satisfaction',
            'GED': 'GED',
            'DOCS': 'Documents',
            'DOCS_INTERNES': 'Internes',
            'DOCS_EXTERNES': 'Externes',
            'TAB_BORD': 'Tab. bord',
            'TAB_BORD_ENR': 'Tab. bord',
            'ENREGISTREMENTS': 'Enregistrements',
            'EDITIONS': 'Editions',
            'FORMS': 'Formulaires',
            'PAPIERS': 'Papiers',
            'GRH': 'GRH',
            'EMPLOYES': 'Employés',
            'POSTE': 'Fiches de poste',
            'QUESTIONNAIRE': 'QCM d\'évaluation',
            'INDICATEUR': 'Indicateurs',
            'AUDITS': 'Audits',
            'RISK_MANGEMENT': 'Gestion des risques',
            'SETTING': 'Paramétrage',
            'GENERAL': 'Général',
            'PAYS': 'Pays',
            'CITY': 'Villes',
            'PROCESS': 'Processus',
            'SITE': 'Sites',
            'SUJET': 'Sujets',
            'IMPACT': 'Impacts',
            'INCIDENCE': 'Incidences',
            'FREQUENCE': 'Fréquences',
            'DETECTABILITE': 'Détectabilités',
            'PREUVE_EFFICACITE': 'Preuves d\'efficacité',
            'ETAT_ACTION': 'États d\'action',
            'CATEGORIE_EMETTEUR': 'Catégories des émetteurs',
            'BATTERIE_QUESTION': 'Batterie de questions',
            'TYPE_DOC_EXTERNE': 'Types docs externes',
            'ORIGINE_DOC_EXTERNE': 'Origines docs externes',
            'PARTIE_INTERESSEE': 'Parties intéressées',
            'TYPE_ENREGISTREMENT': 'Types enregistrements',
            'ETABLISSEMENT': 'Établissements',
            'TYPE_DIPLOME': 'Types des diplômes',
            'SPECIALITE': 'Spécialités',
            'DOMAINE_COMPETENCE': 'Domaines des compétences',
            'COMPETENCE': 'Compétences',
            'ACTION_FORMATION': 'Actions de formation',
            'CRITERE_MAINTIEN': 'Critères de maintien',
            'SERVICE': 'Services',
            'VACCINATION': 'Vaccinations',
            'QUESTION_EVALUATION': 'Questions d\'évaluation',
            'GESTION_ACCES': 'Gestion d\'accès',
            'USERS': 'Utilisateurs',
            'ROLES': 'Rôles',
            'TYPEPANNE': 'Types des pannes',
            'INTERVENTION': 'Interventions',
            'PIECE': 'Piéces',
            'TACHE': 'Tâches',
            'TYPEINTERVENTION': 'Types d\'intervention',
            'TYPETACHEINTERVENTION': 'Types des tâches des interventions',
            'UNITEDUREE': 'Unité de la durée',
            'STATUTTACHE': 'Statuts des tâches',
            'MAINTENANCE': 'Maintenance',
            'Marque': 'Marques',
            'Model': 'Modèles',
            'Criticite': 'Criticités',
            'Type': 'Types',
            'Fournisseur': 'Fournisseurs',
            'ETAT': 'États de réception',
            'CHAMPUTILISATION': 'Champs d\'utilisation',
            'DISCIPLINE': 'Disciplines',
            'EMPLACEMENT': 'Emplacements',
            'CLIENT': 'Clients',
            'GMAO': 'GMAO',
            'EQUIPEMENT': 'Equipements',
            'PANNE': 'Pannes',
            'PRIORITE': 'Priorité',
            'RISK': 'Risques',
            'ASSESSMENT': 'Évaluation',
            'HIGHRISK': 'Avertissement',
            'SEVERITY': 'Gravités',
            'CRITICALITY': 'Criticités',
            'HIGHRISKPARAMS': 'Paramétre du risque élevé',
            'REVUE_DIRECTION': 'Revue de direction',
            'GED_STAT': 'Statistiques',
            'RECENT': 'Documents récents',
            'GROUPE': 'Groupes',
            'ACTIONLOG': 'Journal des actions',
            'RAPPEL': 'Paramétres des rappels',
            'STOCK': 'Stock',
            'ARTICLE': 'Articles',
            'FAMILLE' : 'Famille',
            'TYPE_ARTICLE' : 'Type d\'article',
            'UNITE' : 'Unité', 'CONTACT_FOURNISSEUR' : 'Contact fournisseur',
            'DEMANDEACHAT' : 'Demandes d\'achat',
            'BCMD' : 'Bons de commande',
            'BRECEP' : 'Bons de réception',
			'BOUT' : 'Bons de sortie',
            'BIN' : 'Bons d\'entrée',
            'BRET' : 'Bons de retour',
            'INVENTAIRE' : 'Inventaires',
            'FACTURE' : 'Factures',
            'REGLEMENT' : 'Règlements',
            'BANQUE' : 'Banques',
            'MODE_PAIEMENT' : 'Modes de paiement',
            'CAISSE' : 'Caisses',
            'LIST_STOCK' : 'Liste des stocks',
            'LOT_EN_STOCK' : 'Lots en stock',
            'SITUATION_FOURNISSEUR' : 'Situation des fournisseurs',
            'DOCUMENTATION': 'Documentation',
            'RATING': 'Évaluation',
            'COMPAGNE': 'Compagne',
            'VALUERATING': 'Valeurs évaluation',
            'OPTIONS_GENERALES': 'Options générales',
            'BORNE': 'Borne',
            'TODO':'To-Do',
            'TODO_LIST':'To-Do',
            'EVALUATION_FOURNISSEUR': 'Évaluation fournisseur',
            'CRITERE_EVALUATION_FOURNISSEUR': 'Critères d\'évaluation',
            'CATEGORIE_FOURNISSEUR': 'Catégories',
            'EVAL': 'Évaluation fournisseur',
            'EVALUATION_CATEGORIE_FOURNISSEUR': 'Évaluation catégorie',
        }
    }
};
